import * as React from 'react';

function SvgHome(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg
			fill="none"
			height="18"
			viewBox="0 0 20 18"
			width="20"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				clipRule="evenodd"
				d="M19.7447 6.7263L10.4122 0.128171C10.2949 0.0451422 10.1501 0 10.0009 0C9.85175 0 9.70691 0.0451422 9.58968 0.128171L0.254677 6.72742C0.185815 6.77617 0.128297 6.83666 0.0854073 6.90542C0.0425172 6.97417 0.0150951 7.04986 0.00470655 7.12816C-0.00568201 7.20646 0.00116647 7.28583 0.024861 7.36175C0.0485555 7.43766 0.0886319 7.50863 0.142802 7.57061C0.196972 7.63258 0.264176 7.68435 0.340575 7.72295C0.416974 7.76155 0.501073 7.78623 0.58807 7.79558C0.675067 7.80493 0.763258 7.79877 0.847608 7.77744C0.931958 7.75612 1.01082 7.72005 1.07968 7.6713L1.99968 7.0188V17.3992C1.99968 17.731 2.29843 17.9988 2.66593 17.9988H17.3334C17.5101 17.9988 17.6796 17.9356 17.8045 17.8232C17.9295 17.7107 17.9997 17.5582 17.9997 17.3992V7.0188L18.9209 7.6713C19.0604 7.76922 19.2372 7.81353 19.4129 7.79456C19.5885 7.77559 19.7487 7.69488 19.8584 7.57005C19.9666 7.4443 20.0154 7.2853 19.9944 7.12741C19.9733 6.96952 19.8841 6.82543 19.7459 6.7263H19.7447ZM12.6659 16.7984H7.33343V10.1992H12.6659V16.7984ZM16.6659 16.7984H13.9997V9.59842C13.9997 9.43939 13.9295 9.28687 13.8045 9.17442C13.6796 9.06197 13.5101 8.9988 13.3334 8.9988H6.66593C6.57843 8.9988 6.4918 9.01431 6.41096 9.04444C6.33013 9.07457 6.25668 9.11874 6.19482 9.17442C6.13295 9.2301 6.08387 9.2962 6.05039 9.36895C6.01691 9.4417 5.99968 9.51968 5.99968 9.59842V16.7984H3.33218V6.07717L9.99968 1.36117L16.6659 6.07492V16.7984Z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	);
}

export default SvgHome;
